"use client";

import SectionTitle from "@/components/ui/SectionTitle";
import { useState } from "react";
import {
    MousePointerClick,
    Search,
    Facebook,
    Linkedin,
    Tags,
    LineChart,
    ChartColumn,
    Flame,
    ScanSearch,
    Zap,
    Workflow,
    Building2,
    PlugZap,
    Bot,
    MessagesSquare,
    Hash,
    Video,
} from "lucide-react";

const tabs = [
    {
        id: "ad-platforms",
        label: "Ad Platforms",
        items: [
            { name: "Google Ads", icon: MousePointerClick },
            { name: "Bing Ads", icon: Search },
            { name: "Meta Ads Manager", icon: Facebook },
            { name: "LinkedIn Campaign Manager", icon: Linkedin },
        ],
    },
    {
        id: "analytics",
        label: "Analytics & Attribution",
        items: [
            { name: "Google Tag Manager", icon: Tags },
            { name: "SEMrush", icon: LineChart },
            { name: "GA4", icon: ChartColumn },
        ],
    },
    {
        id: "cro",
        label: "CRO & UX",
        items: [
            { name: "Hotjar", icon: Flame },
            { name: "MS Clarity", icon: ScanSearch },
        ],
    },
    {
        id: "reporting",
        label: "Automation & Retention",
        items: [
            { name: "Zapier", icon: Zap },
            { name: "Make", icon: Workflow },
            { name: "Zoho", icon: Building2 },
            { name: "Pabbly Connect", icon: PlugZap },
            { name: "HubSpot", icon: Bot },
        ],
    },
    {
        id: "collaboration",
        label: "Collaboration",
        items: [
            { name: "Teams", icon: MessagesSquare },
            { name: "Slack", icon: Hash },
            { name: "Zoom", icon: Video },
        ],
    },
];
export default function ToolStack() {
    const [activeTab, setActiveTab] = useState(tabs[0].id);

    const activeItems =
        tabs.find((t) => t.id === activeTab)?.items || [];

    return (
        <section className="py-16 lg:py-20 xl:py-24 2xl:py-32">
            <div className="container mx-auto flex flex-col gap-8 lg:gap-12 px-4">
                <div className="custom-container mx-auto">
                    <SectionTitle
                        badge="Functions & Tools"
                        title="Our Tech Stack & Tools"
                        align="center"
                    />
                </div>

                <div className="w-full max-w-7xl mx-auto">
                    {/* Tabs */}
                    <div className="grid grid-cols-2 xl:grid-cols-5 gap-2">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`relative cursor-pointer transition-all duration-300
                  py-3 px-4 lg:px-6
                  font-semibold text-sm lg:text-base
                  ${activeTab === tab.id
                                        ? "bg-slate-800 text-white"
                                        : "bg-[#F2F2F2] text-slate-600 hover:bg-slate-200"
                                    }
                  lg:-skew-x-12`}
                            >
                                <span className="lg:skew-x-12 block">
                                    {tab.label}
                                </span>
                            </button>
                        ))}
                    </div>

                    {/* Tools Grid */}
                    <div className="mt-5 bg-white border lg:border-0 border-slate-200">
                        <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
                            {activeItems.map((item, idx) => {
                                const Icon = item.icon;

                                return (
                                    <div
                                        key={idx}
                                        className="flex flex-col items-center justify-center gap-2.5 
          p-4 text-center border border-slate-200
          hover:bg-slate-50 transition-colors"
                                    >
                                        <div className="border border-gray-200 rounded p-1.5 shadow">

                                        <Icon className="w-7 h-7 text-xl text-slate-700 font-bold " />
                                        </div>
                                       

                                        <span className="font-medium text-slate-700 text-md">
                                            {item.name}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}